export function ArrowSquareUp({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM12.045 10.5C11.9325 10.6125 11.79 10.665 11.6475 10.665C11.505 10.665 11.3625 10.605 11.25 10.5L9 8.25L6.75 10.5C6.5325 10.7175 6.1725 10.7175 5.955 10.5C5.7375 10.2825 5.7375 9.9225 5.955 9.705L8.6025 7.0575C8.82 6.84 9.18 6.84 9.3975 7.0575L12.045 9.705C12.2625 9.9225 12.2625 10.275 12.045 10.5Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
